export class EscapeHTMLAndHighlightValueConverter {
	public toView(value: string | null | undefined, query: string = '') {
		if (value === null || value === undefined) {
			return value;
		}
		value = value.escapeHtml();
		const reQuery = new RegExp(`(${query})`, 'ig');
		return query && reQuery.test(value)
			? value.replace(reQuery, '<span class="highlight">$1</span>')
			: value;
	}
}
